"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkout = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const CheckoutContext_1 = require("./CheckoutContext");
const useCheckoutSubmit_1 = require("./useCheckoutSubmit");
const __1 = require("..");
function CheckoutContent({ mail, logo, remarksLabel, options, }) {
    const { data: cartData, total, loading } = (0, __1.useCart)({ networkOnly: true });
    const onSubmit = (0, useCheckoutSubmit_1.useCheckoutSubmit)();
    const mappedProducts = cartData.products.map((product) => {
        var _a, _b, _c;
        return ({
            id: product.id,
            currency: product.currency,
            price: (_a = product.price) !== null && _a !== void 0 ? _a : 0,
            regularPrice: (_b = product.regularPrice) !== null && _b !== void 0 ? _b : null,
            lowestPriceBeforeSale: (_c = product.lowestPriceBeforeSale) !== null && _c !== void 0 ? _c : null,
            quantity: product.quantity,
            taxRate: 23,
            title: product.title,
            variant: { attributes: product.attributes.map((v) => ({ value: v })) },
        });
    });
    return ((0, jsx_runtime_1.jsx)(__1.CheckoutView, { logo: logo, products: mappedProducts, vouchers: cartData.vouchers, total: total, onSubmit: onSubmit, loading: loading, mail: mail, remarksLabel: remarksLabel, options: options }));
}
function Checkout(props) {
    var _a;
    const theme = (0, app_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(CheckoutContext_1.CheckoutContextProvider, Object.assign({ tokens: (_a = props.tokens) !== null && _a !== void 0 ? _a : {} }, { children: (0, jsx_runtime_1.jsx)(CheckoutContent, Object.assign({}, props)) })), (0, jsx_runtime_1.jsx)(ui_1.ToastContainer, { theme: theme })] }));
}
exports.Checkout = Checkout;
